export default function TasksSolved() {
  const tasks = [
    { icon: 'ri-emotion-happy-line', title: 'Преодоление страха звонков', desc: 'Убираем психологический барьер перед первым звонком. Менеджер перестаёт бояться трубки.' },
    { icon: 'ri-vip-crown-line', title: 'Выход на ЛПР', desc: 'Учим проходить секретарей и находить лиц, принимающих решения, в любой компании.' },
    { icon: 'ri-chat-smile-2-line', title: 'Открытие разговора', desc: 'Первые фразы, которые вызывают интерес, а не желание положить трубку.' },
    { icon: 'ri-timer-line', title: 'Первые 30 секунд разговора', desc: 'Как зацепить внимание и создать желание продолжить диалог с первых слов.' },
    { icon: 'ri-heart-line', title: 'Интерес вместо давления', desc: 'Превращаем холодный звонок в полезный для клиента разговор без агрессивных продаж.' },
    { icon: 'ri-shield-user-line', title: 'Работа с секретарями', desc: 'Выстраиваем доверительные отношения с помощниками руководителей.' },
    { icon: 'ri-forbid-line', title: 'Работа с «нам ничего не нужно»', desc: 'Техники, которые превращают самое частое возражение в начало диалога.' },
    { icon: 'ri-calendar-check-line', title: 'Назначение встречи', desc: 'Доводим разговор до конкретной договорённости с датой и временем.' },
    { icon: 'ri-search-eye-line', title: 'Выявление интереса', desc: 'Учим задавать вопросы, которые раскрывают реальные потребности клиента.' },
    { icon: 'ri-contacts-line', title: 'Договорённость о следующем контакте', desc: 'Каждый звонок завершается чётким следующим шагом, а не «я вам перезвоню».' },
    { icon: 'ri-database-2-line', title: 'Ведение CRM', desc: 'Системный подход к фиксации договорённостей и планированию следующих контактов.' },
    { icon: 'ri-bar-chart-grouped-line', title: 'Системная работа с базой', desc: 'Превращаем хаотичный обзвон в управляемый процесс с измеримыми показателями.' },
  ];

  return (
    <section id="tasks" className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Какие задачи решает обучение холодным звонкам
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Программа закрывает все ключевые проблемы, с которыми сталкиваются менеджеры при холодном обзвоне — от страха первого звонка до системной работы с базой клиентов.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 max-w-6xl mx-auto">
          {tasks.map((task, i) => (
            <div key={i} className="bg-white rounded-xl p-5 border border-gray-100 hover:border-teal-200 hover:shadow-md transition-all duration-300 group flex items-start gap-4">
              <div className="w-10 h-10 bg-teal-600 rounded-lg flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform">
                <i className={`${task.icon} text-lg text-white`}></i>
              </div>
              <div>
                <h3 className="text-sm font-bold text-gray-900 mb-1">{task.title}</h3>
                <p className="text-xs text-gray-600 leading-relaxed">{task.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <button
            onClick={() => {
              const el = document.getElementById('contact');
              if (el) el.scrollIntoView({ behavior: 'smooth' });
            }}
            className="bg-teal-600 text-white px-8 py-4 rounded-lg text-base font-semibold hover:bg-teal-700 transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
          >
            Обучить менеджеров холодным звонкам
            <i className="ri-arrow-right-line"></i>
          </button>
        </div>
      </div>
    </section>
  );
}